import { render, staticRenderFns } from "./Verification.vue?vue&type=template&id=6c5894fe&scoped=true"
import script from "./Verification.vue?vue&type=script&lang=js"
export * from "./Verification.vue?vue&type=script&lang=js"
import style0 from "./Verification.vue?vue&type=style&index=0&id=6c5894fe&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c5894fe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Karl\\Code\\customs_clearance\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c5894fe')) {
      api.createRecord('6c5894fe', component.options)
    } else {
      api.reload('6c5894fe', component.options)
    }
    module.hot.accept("./Verification.vue?vue&type=template&id=6c5894fe&scoped=true", function () {
      api.rerender('6c5894fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/const/Verification.vue"
export default component.exports